import React from "react";

import { StyledText } from "./styled";

const Text = ({ styles = {}, children }) => (
  <StyledText styles={styles}>{children}</StyledText>
);

export default Text;
